import { Box, Grid, Typography } from 'apollo-react';
import React from 'react';

import PackagesTable from './PackagesTable';
import { EXPORT_GUIDE } from '../../constants/export.constants';
import InfoBlock from '../common/InfoBlock';

const StartExportPackages = ({ handleUpdatePackages, selectedPackages }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          component="span"
          display="block"
          dangerouslySetInnerHTML={{ __html: EXPORT_GUIDE.packagesSteps.a }}
        />
      </Grid>

      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <PackagesTable
            handleUpdatePackages={handleUpdatePackages}
            selectedPackages={selectedPackages}
          />
        </Box>
      </Grid>

      <Grid item xs={12}>
        <Typography
          component="span"
          display="block"
          dangerouslySetInnerHTML={{ __html: EXPORT_GUIDE.packagesSteps.b }}
        />
      </Grid>

      <Grid item xs={12}>
        <InfoBlock type="warning">
          <Typography
            color="textSecondary"
            dangerouslySetInnerHTML={{ __html: EXPORT_GUIDE.warning }}
          />
        </InfoBlock>
      </Grid>
    </Grid>
  );
};
export default StartExportPackages;
